export type DataFinderSearchField = {
	campos: string;
	default?: boolean;
};

/**
 * Campo inicial de Classificação (Delphi DataFinderDefault / KeyLabel).
 *
 * Prioridade:
 * 1) campo já válido na lista (reabertura do modal)
 * 2) default:true do backend (ex.: DF_E468 → Empresa, como no Delphi)
 * 3) keyField se existir nas opções
 * 4) primeiro da lista
 */
export function resolveInitialSearchField(params: {
	currentSearchField: string;
	keyField: string;
	searchFields: DataFinderSearchField[];
}) {
	const keyFieldSearch = params.keyField
		? params.searchFields.find((field) => field.campos === params.keyField)?.campos
		: undefined;
	const defaultSearchField = params.searchFields.find((field) => field.default === true)?.campos
		?? params.searchFields[0]?.campos
		?? "";

	if (!params.currentSearchField || !params.searchFields.some((field) => field.campos === params.currentSearchField)) {
		// Delphi: DataFinderDefault = True (Empresa em DF_E468) tem prioridade sobre FieldSearch
		return defaultSearchField || keyFieldSearch || "";
	}

	return params.currentSearchField;
}